import { CountryService, ResponseError } from '@ynap/api-utils';
import { timeout, delay } from '@ynap/promise-utils';
import { FETCH_PROVINCES_REQUEST, FETCH_PROVINCES_SUCCESS, FETCH_PROVINCES_ERROR } from '../constants/ActionTypes';

function fetchProvincesRequest() {
    return {
        type: FETCH_PROVINCES_REQUEST,
    };
}

function fetchProvincesSuccess(payload) {
    return {
        type: FETCH_PROVINCES_SUCCESS,
        payload,
    };
}

function fetchProvincesError() {
    return {
        type: FETCH_PROVINCES_ERROR,
    };
}

export default function fetchProvinces(countryCode) {
    return (dispatch, getState) => {
        const { config } = getState();
        const { addressValidationService, global, head } = config;
        const { baseUrl } = addressValidationService || global.services.addressValidation;
        const { brandId } = global.application;
        const { clientRequest } = head || config;

        const request = CountryService.getProvinces({ baseUrl, brandId, countryCode });
        dispatch(fetchProvincesRequest());

        //todo look at if this is shareable across state packages
        return delay(timeout(fetch(request), clientRequest.timeout), clientRequest.delay)
            .then((response) => {
                const { ok } = response;
                if (ok) {
                    return response
                        .json()
                        .then((json) => dispatch(fetchProvincesSuccess([json.countries])))
                        .catch((error) => fetchProvincesError(error));
                }

                throw new ResponseError(response);
            })
            .catch((error) => {
                dispatch(fetchProvincesError(error));
                throw error;
            });
    };
}
